export const appContainerStyle = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  overflow: "hidden",
  backgroundColor: "var(--M-background93)",
  borderRadius: "12px",
  boxShadow:"0px 0px 20px 0px rgba(0, 0, 0, 0.18)"
};

export const appInputOutputContainerStyle = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  flexGrow: 1,
  overflowY: {xs:"auto", md:"hidden"},
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};
